<template>
	<div class="app_body">
		<div v-if="shopData !== ''">
			<h2 class="shop_name">{{ shopData['販売店名'] }}</h2>

			<div class="info_body">
				<div class="map">
					<GoogleMapLoader :init-lat="shopData['緯度']" :init-lng="shopData['経度']"/>
				</div>
				<div class="info">
					<dl>
						<div>
							<dt>住所</dt>
							<dd>〒{{ shopData['郵便番号'] }}<br class="sp"> {{ shopData['住所'] }}</dd>
						</div>
						<div>
							<dt>TEL</dt>
							<dd>{{ shopData['TEL'] }}</dd>
						</div>
						<div>
							<dt>FAX</dt>
							<dd>{{ shopData['FAX'] }}</dd>
						</div>
						<div>
							<dt>web</dt>
							<dd><a :href="shopData['URL']" target="_blank">{{ shopData['URL'] }}</a></dd>
						</div>
						<div>
							<dt>E-mail</dt>
							<dd>{{ shopData['E-Mail'] }}</dd>
						</div>
						<div>
							<dt>営業時間</dt>
							<dd>{{ shopData['営業時間'] }}</dd>
						</div>
						<div>
							<dt>定休日</dt>
							<dd v-html="shopData['定休日']"></dd>
						</div>
						<div>
							<dt>交通機関</dt>
							<dd v-html="shopData['交通機関']"></dd>
						</div>
						<div>
							<dt>駐車場</dt>
							<dd>{{ shopData['駐車場'] }}</dd>
						</div>
						<div class="shop_pr">
							<dt>お店のPR</dt>
							<dd>
								<p v-html="shopData['お店のPR']"></p>
								<div class="pc shop_pr_img"><img v-lazy="shopData_imagePath + 'a.jpg?'+ cacheRecover" alt="店舗画像"></div>
								<div class="pc shop_pr_img"><img v-lazy="shopData_imagePath + 'b.jpg?'+ cacheRecover" alt="店舗画像"></div>
								<div class="pc shop_pr_img"><img v-lazy="shopData_imagePath + 'c.jpg?'+ cacheRecover" alt="店舗画像"></div>
							</dd>
						</div>
						<div class="shop_pr_sp sp">
							<div><img v-lazy="shopData_imagePath + 'a.jpg?'+ cacheRecover" alt="店舗画像"></div>
							<div><img v-lazy="shopData_imagePath + 'b.jpg?'+ cacheRecover" alt="店舗画像"></div>
							<div><img v-lazy="shopData_imagePath + 'c.jpg?'+ cacheRecover" alt="店舗画像"></div>
						</div>
					</dl>
				</div>
			</div>
		</div>
		<div class="notshop" v-else>{{ result }}</div>

		<div class="buttons back">
			<router-link to="/">販売店検索TOPに戻る</router-link>
		</div>
	</div>
</template>

<script>
import GoogleMapLoader from '@/components/GoogleMapLoader'

export default {
	name: "Shop",
	props: {id: Number},
	data: function () {
		return {
			ID: this.id,
      result:'検索中...'
		}
	},
	components: {GoogleMapLoader},
  computed: {
		shopData() {
			for (let i = 0; i < this.$store.state.excel_data.length; i = (i + 1) | 0) {
				if(this.$store.state.excel_data[i]['ID'] === this.ID && this.$store.state.excel_data[i]['表示状態'] === 0) {
					return this.$store.state.excel_data[i];
				}
			}

			//店舗が存在しない場合は空をリターン
			return '';

		},
		shopData_imagePath() {
			return '/shop/data/images/' + this.shopData['ファイル名'];
		},
		cacheRecover(){
			return (new Date()).getTime();
		}
	},
  mounted() {
    let _this = this;
    let time = setInterval(function(){
      _this.result =  '該当の店舗は存在しません。';
      clearInterval(time);
    },5000)
  },
	methods:{

	}
}
</script>

<style scoped>
.app_body {
	width: 100%;
	max-width: 1200px;
	margin: 0 auto 20px;
	padding: 0 25px 0 10px;
}

h2.shop_name {
	padding-left: 10px;
	font-size: 1.8rem;
	font-weight: bold;
	border-bottom: 4px solid var(--toso_base_green);
}

.info_body {
	display: flex;
	justify-content: space-between;
	margin-bottom: 50px;
}

.map {
	flex: 1;
	width: 600px;
	height: 600px;
	padding: 10px;
}

.info {
	flex: 1;
	width: auto;
	margin: 0 0 0 10px;
}

.info dl > div {
	display: flex;
	border-bottom: 1px solid var(--toso_base_gray);
	padding: 20px 10px;
}

.info dl dt {
	font-weight: bold;
	flex: 0 1 20%;
}

.info dl dd {
	flex: 0 1 80%;
}

.info dl > div.shop_pr {
	height: auto;
}

.info dl > div.shop_pr dt,
.info dl > div.shop_pr dd {
	align-items: flex-start;
	flex-flow: column;
}

.info dl > div.shop_pr p,
.info dl > div.shop_pr div,
.info dl > div.shop_pr_sp div {
	margin-bottom: 10px;
}

.info dl > div.shop_pr .shop_pr_img {
	width: 245px;
}

.info dl > div.shop_pr_sp {
	width: 100%;
	display: none;
	flex-flow: column;
	padding: 20px 0;
}

.buttons.back {
	width: 280px;
	height: 32px;
}

.notshop{
	text-align: center;
	margin: 50px 0;
}

@media screen and (max-width: 750px) {
	.app_body {
		margin: 20px auto 20px;
		padding: 0;
		font-size: 1.5rem;
	}

	h2.shop_name {
		padding: 0 0 10px 10px;
	}

	.info {
		margin: 0 10px 0 10px;
	}

	.info dl > div {
		padding: 20px 10px 20px 0;
	}

	.info dl dt {
		flex: 0 1 30%;
	}

	.info dl > div.shop_pr_sp {
		display: flex;
	}

	.info dl > div.shop_pr_sp img {
		width: 100vw;
	}

	.info_body {
		flex-flow: column;
		margin-bottom: 30px;
	}

	.map {
		padding: 0;
		margin: 10px 0 30px;
		width: 100%;
		height: 408px;
	}

	.info dl > div:first-child {
		border-top: 1px solid var(--toso_base_gray);
	}
}
</style>